export enum SingleChoiceComparison {
  is = 0,
  isNot = 1,
  isUpdated = 2,
  was =3,
  wasNot=4,
  isBlank = 5,
  isPresent = 6,
}